<div id="payment" style="display: flex;flex-direction: column;">
   <div style="width: 100%;">
      <app-up-slide [cruiseStartDate]="this.cruiseStartDate" [startEndDates]="this.startEndDates"
         [position]="this.position" [startEndDatesType]="startEndDatesType" [numberPage]="3"
         [priceWithAirFare]="priceWithAirFare" [urlLogoCruise]="this.createUrlLogoCruise()" [promotion]="this.promotion"
         [cruise]="this.cruise" [cruiseItineraryDuration]="this.cruiseItineraryDuration">
      </app-up-slide>
      <br>
      <app-tour-summary [asideBoolean]=true [boatImageResource]="this.boatImagesResource" [cruiseInput]="cruise">
      </app-tour-summary>
      <div class="modules-ecomm" id="startCheckoutThird">
         <div class="headmod"
            [ngStyle]="{ 'background-color':  this.companyParamsService.getCompanyParams() == undefined ?('blue'): ('#'+this.companyParamsService.getMainColor()) }">
            Payment Options</div>
         <div class="note-confirm confirmed" *ngIf="this.isAutoPaymentAccepted === false">
            <p><strong>We are almost there! </strong></p>
            <p>Given that your cruise will take place within the next 72 hours, one of our Travel Advisors will contact
               you
               as soon as possible via e-mail to arrange your payment method and confirm your tour. </p>
            <p>Thank you for contacting us.</p>
         </div>

        <!-- PLACE TO PAY MESSAGE ERROR HEADER -->
        <div class="col-12" style="padding: 1em;" *ngIf="isVisibleMessageErrorBlockPlacetopay()">
          <app-error-payment [visible]="true" [errorHeader]="'Oops! Something went wrong!'"
            [errorText]="placetopayService.onHoldErrorMessage(companyParamsService.getInfoEmail())">
          </app-error-payment>
          <div class="row" style="margin-top: 30px;">
            <div class="col-12" style="text-align: center;margin-top: auto;">
              <a id="back" class="" href="javascript:void()" href="javascript:returnOrigin()"> Back to search
                results </a>
            </div>
          </div>
        </div>



         <!-- STRIPE MESSAGE ERROR HEADER -->
         <div class="row" style="padding: 1em;" *ngIf="isVisibleMessageErrorBlockDeparture() ">
            <div class="col-12">
               <app-error-payment [visible]="true" [errorHeader]="'Oops! Something went wrong!'"
                  [errorText]="stripeService.departureErrorMessageStripe(companyParamsService.getInfoEmail())"></app-error-payment>
            </div>
            <div class="row" style="margin-top: 30px;">
               <div class="col-12" style="text-align: center;margin-top: auto;">
                  <a id="back" class="" href="javascript:void()" href="javascript:returnOrigin()"> Back to search
                     results </a>
               </div>
            </div>
         </div>
         <div class="mod-content active"
            style="min-height: 45rem !important;" *ngIf="!isVisibleMessageErrorBlockDeparture() && !isVisibleMessageErrorBlockPlacetopay()">
            <div class="pricesvalue">
               <h3>Payment Options: </h3>
               <br>
               <div style="display: flex;">
                  <div class="left" style="flex: 1; display: flex;">
                     <label for="reserve" style="display: flex;"
                        *ngIf="hasThirtyPercent && this.companyParamsService.getStatusPartialPayment()">

                        <input type="checkbox" name="reserve" id="reserve" [checked]="!isSelectedThirtyPercent"
                           (click)="selectThirtyPercent()" style="margin-right: 4px;">
                        <p class="text-partial-payment">
                           Send full amount now
                        </p>
                     </label>
                     <div *ngIf="hasThirtyPercent && this.companyParamsService.getStatusPartialPayment()"
                        style="display: flex; width: 52%; justify-content: flex-end;">
                        <h3 style="margin-top: 0px;" class="text-partial-payment">US$
                           {{allValuePrice.toLocaleString('en',
                           {maximumFractionDigits:2})}}</h3>
                     </div>
                  </div>
                  <div class="right" style="flex: 1; display: flex;">
                     <label for="reserve" style="display: flex;"
                        *ngIf="hasThirtyPercent && this.companyParamsService.getStatusPartialPayment()">

                        <input type="checkbox" name="reserve" id="reserve" [checked]="isSelectedThirtyPercent"
                           (click)="selectThirtyPercent()" style="margin-right: 4px;">
                        <p class="text-partial-payment">
                           Reserve with a {{this.companyParamsService.getPercentPartialPayment()}}% deposit only
                        </p>
                     </label>
                     <div *ngIf="hasThirtyPercent && this.companyParamsService.getStatusPartialPayment()"
                        style="display: flex; width: 38%; justify-content: flex-end;">

                        <h3 style="margin-top: 0px;" class="text-partial-payment">US$
                           {{onlyThirtyPrice.toLocaleString('en',
                           {maximumFractionDigits:2})}}
                        </h3>
                     </div>
                  </div>
               </div>
            </div>
            <div class="shadowBox" *ngFor="let item of paymentMethods;  let i = index"
               [ngClass]="{'selected': item.selected}"
               [@selectionAnimation]="item.selected ? 'selected' : 'unselected'">
               <div class="headline" style="cursor: pointer;" (click)="changePaymentMethod(i)">
                  <h4>
                     <strong>› {{item.name}}</strong>
                  </h4>
               </div>
               <div class="miniContainer" [collapse]="!item.selected" [@expandCollapse]="item.selected ? 'expanded' : 'collapsed'">
                  <div class="row" style="padding-left: 5px;">

                     <p>
                        {{item.description}}
                     </p>
                     <div class="row-image" (click)="flagClick=true">
                        <img *ngFor="let icon of item?.icons" src="assets/images/payments/{{icon.img}}"
                           alt="{{icon.value}}" height="{{icon.heightValue}}" class="mr-2 mt-2">
                        <div *ngIf="item.type == paymentMethodTypeEnum.PAYPAL_CHECKOUT" id="paypal-button-payment"
                           [ngStyle]="{ 'pointer-events':  termsConditionPaytransfer ?'all':'none'}"></div>
                     </div>
                     <br>
                     <br>
                     <input type="checkbox" name="terms" value="TermsCondition" [checked]="termsConditionPaytransfer"
                        (change)="this.changeTermsPayTransfer($event.target.checked)">
                     <a style="color: blueviolet;" [href]="companyParamsService.getTermsConditions()" target="_blank">
                        I agree to the Terms & Conditions.
                     </a>
                     <br>
                     <div *ngIf="item.type === paymentMethodTypeEnum.PLACETOPAY">
                        <input type="checkbox" name="terms2" value="PrivacyData" [checked]="termsPrivacyData"
                           (change)="this.changePrivacyData($event.target.checked)">
                        <a style="color: blueviolet;" [href]="companyParamsService.getDataProtectedUrl()" target="_blank">
                           I agree to the Privacy Policy and how my data is used.
                        </a>
                        <br>
                        <br>
                     </div>
                     <br>
                     <!--STRIPE PAYMENT METHOD COMPONENT -->
                     <div class="stripe-design" (click)="flagClick=true">
                        <!-- STRIPE COMPONENT -->
                        <div class="col-12" style="padding-top: 25px;"
                           *ngIf="item.type === paymentMethodTypeEnum.STRIPE_CHECKOUT">
                           <app-error-payment
                              [visible]="stripeService.viewMessageErrorPaymet(typeErrorPaymentStripe) && !stripeService.loading(paymentOption) && !stripeService.exceededAttemps(attemptPaymentStripe)"
                              [errorHeader]="'Oops! Something went wrong!'"
                              [errorText]="stripeService.paymentErrorMessageStripe(purchaseRequestService.getErrorPayment(),companyParamsService.getInfoEmail())"></app-error-payment>
                           <app-error-payment [visible]="stripeService.exceededAttemps(attemptPaymentStripe)"
                              [errorHeader]="'Oops! Payment Attempt Limit Reached'"
                              [errorText]="stripeService.attempsErrorMessageStripe(companyParamsService.getInfoEmail())"></app-error-payment>
                        </div>
                        <div class="row" *ngIf="item.type === paymentMethodTypeEnum.STRIPE_CHECKOUT">
                           <div class="col-12">
                              <div class="text-center">
                                 <app-stripe-payment *ngIf="!stripeService.exceededAttemps(attemptPaymentStripe)"
                                    [totalToPay]="purchaseTotalPrice" [termsCondictios]="termsConditionPaytransfer"
                                    [loading]="stripeService.loading(paymentOption)"
                                    [secundaryColor]="this.companyParamsService.getSecundaryColor()"
                                    (executeStripe)="executeWithStripe()"
                                    [ngStyle]="{ 'pointer-events':  termsConditionPaytransfer ?'all':'none'}"></app-stripe-payment>
                              </div>
                           </div>
                        </div>
                        <!-- STRIPE COMPONENT -->
                     </div>
                      <!-- PLACETOPAY COMPONENT-->
                        <app-status-payment *ngIf="item.type === paymentMethodTypeEnum.PLACETOPAY && (!placetopayPaymentApproved || placetopayLoading)" [request]="placetopayPaymentRequest" ></app-status-payment>
                        <!-- Error por intentos excedidos PlaceToPay.
                             Se muestra solo cuando el flujo ya NO está en espera: es decir, cuando el
                             servicio de consulta ya devolvió el resultado (APPROVED/REJECTED) o cuando
                             el lightbox se cerró sin un pago pendiente en curso. -->
                        <div class="col-12" style="padding-top: 25px;" *ngIf="item.type === paymentMethodTypeEnum.PLACETOPAY && exceededAttemptsPlacetopay() && !placetopayPaymentApproved && !placetopayWaitingStatus && !placetopayLoading">
                           <app-error-payment
                              [visible]="true"
                              [errorHeader]="'Oops! Payment Attempt Limit Reached'"
                              [errorText]="getPlacetopayAttemptsErrorMessage()">
                           </app-error-payment>
                        </div>
                        <div class="row" *ngIf="(item.type === paymentMethodTypeEnum.PLACETOPAY && !exceededAttemptsPlacetopay() && !placetopayPaymentApproved) || placetopayLoading">
                           <div class="col-12">
                              <div class="text-center" (click)="flagClick=true">
                                  <!-- Botón Lightbox -->
                                  <app-placetopay-payment #placetopayLightbox
                                    *ngIf="this.placetopayInvocationContext === PlacetopayInvocationContext.LIGHTBOX && !isReturnFromExternalRedirect"
                                    [buttonType]="'lightbox'"
                                    [termsCondictios]="termsConditionPaytransfer"
                                    [loading]="placetopayLoading"
                                    [secundaryColor]="this.companyParamsService.getSecundaryColor()"
                                    (executeLightbox)="onExecutePaymentLightbox()"
                                    (onLightboxClose)="onPaymentClosedLightbox()"
                                    (onLightboxResponse)="onPaymentResponseLightbox($event)"
                                    (onPlacetopayBlocked)="onPlacetopayBlocked($event)"
                                    [ngStyle]="{ 'pointer-events':  (termsConditionPaytransfer && termsPrivacyData) ? 'all' : 'none'}">
                                  </app-placetopay-payment>
                                   <!-- Mostrar estado de procesamiento cuando el pago fue aprobado -->
                                    <div class="row" *ngIf="item.type === paymentMethodTypeEnum.PLACETOPAY && placetopayPaymentApproved">
                                      <div class="col-12">
                                          <div class="text-center">
                                            <p style="margin-top: 10px; color: #28a745; font-weight: bold;">Payment approved! Processing your reservation...</p>
                                          </div>
                                      </div>
                                    </div>
                                    <!-- Mensaje informativo cuando la transacción está en estado PENDING -->
                                    <div class="row" *ngIf="item.type === paymentMethodTypeEnum.PLACETOPAY && placetopayLoading && placetopayPaymentRequest?.status?.status === 'PENDING'">
                                      <div class="col-12">
                                          <div class="text-center">
                                            <p style="margin-top: 10px; font-size: 14px; color: #6c757d;">
                                              <i class="fa fa-info-circle"></i>&nbsp;&nbsp;
                                              Your payment is being processed. Please wait, this may take a few moments.
                                            </p>
                                          </div>
                                      </div>
                                    </div>
                              </div>
                              <small class="help-block" style="color: red;" *ngIf="!termsConditionPaytransfer && flagClick && item.type === paymentMethodTypeEnum.PLACETOPAY">
                                 Please accept the Terms & Conditions to continue.
                              </small>
                              <br>
                              <small class="help-block" style="color: red;" *ngIf="!termsPrivacyData && flagClick && item.type === paymentMethodTypeEnum.PLACETOPAY">
                                 Please accept the Privacy Policy to continue.
                              </small>
                           </div>
                            <div style="margin-top: 10px; padding: 10px; background-color: #f8f9fa; border-left: 3px solid blueviolet; border-radius: 4px;">
                           <p style="margin: 0; font-size: 14px;">
                              <strong>Need help with your payment?</strong><br>
                              <a style="color: blueviolet; text-decoration: underline;" href="{{companyParamsService.getFaqUrl() || '#faq'}}" target="_blank" rel="noopener noreferrer">
                                 Visit our Frequently Asked Questions
                              </a>
                           </p>
                        </div>
                        </div>
                      <!-- PLACETOPAY COMPONENT-->
                     <a href="{{item.linkInfo}}" target="_blank" rel="noopener noreferrer" style="padding-left: 5px;">
                        {{item.linkInfo}}
                     </a>
                  </div>
                  <small class="help-block" style="color: red;" *ngIf="!termsConditionPaytransfer && flagClick && item.type !== paymentMethodTypeEnum.PLACETOPAY">
                     Please accept the Terms & Conditions to continue.
                  </small>
                  <div class="text-center" (click)="flagClick=true"
                     *ngIf="item?.objectConfiguration === undefined || item?.objectConfiguration === null">
                     <a *ngIf="!isProcessing && !isProcessingStripe"
                        [ngStyle]="{ 'pointer-events':  termsConditionPaytransfer ?'all':'none'}"
                        (click)="this.blockCabinNewjson()" href="javascript:void(0)" class="lngnext"> Accept</a>
                  </div>
                  <div class="text-center" (click)="flagClick=true" style="text-align: center;">
                     <img *ngIf="isProcessing || isProcessingStripe" src="assets/images/sending.gif" alt="sending"
                        style="text-align: center;">
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <app-end-slide [thirdString]="this.activeEndSlide" [numberPage]="3"></app-end-slide>
</div>
<app-whatsapp-button [whatsappNumber]="this.whatsappNumber"></app-whatsapp-button>
